import 'bootstrap/js/dist/tooltip'
import {loader} from './loader'
import {displayAuthModal} from './auth-modal'

export default function eligibility() {
  $(document).on('click', '.eligibility-link', function(e){
    e.preventDefault();
    let $this = $(this),
        product_id = $this.data('product-id');

    const isLogged = window.glob_obj.is_logged_in;
    const isInfoFilled = window.glob_obj.is_academic_info_filled;

    if (! isLogged) {
      displayAuthModal();
      return false;
    }

    if (! isInfoFilled) {
      displayAcademicInfoNotFilledModal();
      return false;
    }

    $this.prop("disabled", true);

    $.ajax({
      url: window.glob_obj.ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'aw_eligibility_request',
        _ajax_nonce: window.glob_obj.aw_eligibility_nonce,
        product_id: product_id
      },
      beforeSend: function(){
        loader.show()
      },
      success: function (response) {
        loader.hide()
        $this.prop("disabled", false);

        if (response.status === 'noauth') {
          $('body').append(response.modal);

          $('#auth-modal').modal().on('hidden.bs.modal', function (e) {
            $(this).remove();
          });
        }
        if (response.status === 'success') {
          $this.html(response.message);
          $this.removeClass('pass fail');
          $this.addClass(response.class);
        }
      },
      error: function(error){
        loader.hide()
        $this.prop("disabled", false);
        console.log(error);
      }
    });
  });
}

export function eligibilityTooltip(){
  $('.eligibility-link').hover(function (e){
    const $this = $(this);
    let cl = 'eligibility-tooltip pass';

    if ($this.hasClass('fail')) {
      cl = 'eligibility-tooltip fail';
    }

    const tpl = `<div class="tooltip ${cl}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`;

    $this.tooltip({
      template: tpl
    });
  })
}

export function displayAcademicInfoNotFilledModal(){
  let modal =
      '<div class="modal fade apply-modal" tabindex="-1" role="dialog" id="eligibility-modal">' +
      '<div class="modal-dialog" role="document">' +
      '<div class="modal-content">' +
      '<div class="modal-body">' +
      'In order to check your eligibility for this school, please add your information in the <a style="color: #2ba1c6;" href="/student-dashboard/academic-information/">Applywizard</a> section on your dashboard.' +
      '</div>' +
      '<div class="modal-footer" style="margin: 20px 0 0 0; padding: 0; border: 0;">' +
      '<button type="button" class="btn btn-primary" data-dismiss="modal" style="margin: 0 auto;padding: 7px 21px;">Close</button>' +
      '</div> ' +
      '</div>' +
      '</div>' +
      '</div>';
  $('body').append(modal);
  $('#eligibility-modal').modal().on('hidden.bs.modal', function (e) {
    $(this).remove();
  });
}
